import { render } from "./SigninContent.vue?vue&type=template&id=70236e2a"
import script from "./SigninContent.vue?vue&type=script&lang=js"
export * from "./SigninContent.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SigninContent.vue?vue&type=style&index=0&id=70236e2a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__